import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SvgIconComponent {

  @Input() public icon: string      = '';
  @Input() public urlIcon: string   = '/assets/images/icons/all-icons.svg';
  @Input() public iconClass: string = '';

  constructor() {
    //
  }

}
